<div class="row">
    <div class="col-4">
        <div class="card card-inverse card-info">
            <div class="box bg-info text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.numberOfSoldSessions }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.sessions" | translate }}
                </h6>
            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card card-primary card-inverse">
            <div class="box bg-success text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.totalRevenue | amount }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.totalAmount" | translate }}
                </h6>
            </div>
        </div>
    </div>

    <div class="col-4">
        <div class="card card-inverse card-success">
            <div class="box bg-danger text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.numberOfPurchases }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.totalPurchases" | translate }}
                </h6>
            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card card-inverse card-warning">
            <div class="box bg-warning text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.numberOfChildrenAssignedToCamps }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.enrolledChildren" | translate }}
                </h6>
            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card card-inverse card-secondary">
            <div class="box bg-secondary text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.numberOfCampCreditDaysDeducted }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.numberOfDaysDeducted" | translate }}
                </h6>
            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card card-inverse card-dark">
            <div class="box bg-dark text-center">
                @if (!model) {
                    <div class="box-spinner">
                        <bcu-local-spinner
                            [size]="50"
                            [visible]="true"
                        ></bcu-local-spinner>
                    </div>
                }
                @if (model) {
                    <h1 class="font-light text-white">
                        {{ model.valueOfCampCreditDaysDeducted | amount }}
                    </h1>
                }
                <h6 class="text-white">
                    {{ "Dashboard.valueOfDaysDeducted" | translate }}
                </h6>
            </div>
        </div>
    </div>
</div>
